import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter, Github } from 'lucide-react';

const CardBack = ({ profile }) => {
  return (
    <div className="card-face absolute w-full h-full backface-hidden rotate-y-180 bg-gradient-to-br from-blue-900 via-purple-900 to-slate-900 rounded-2xl shadow-xl border border-blue-700/50 p-6">
      <div className="h-full flex flex-col justify-between">
        <div>
          <h4 className="text-xl font-bold text-white mb-4">Contacto</h4>
          <div className="space-y-3">
            <div className="flex items-center gap-3 text-slate-200">
              <Mail size={18} className="text-blue-400 flex-shrink-0" />
              <span className="text-sm truncate">{profile.email}</span>
            </div>
            <div className="flex items-center gap-3 text-slate-200">
              <Phone size={18} className="text-purple-400 flex-shrink-0" />
              <span className="text-sm">{profile.phone}</span>
            </div>
            <div className="flex items-center gap-3 text-slate-200">
              <MapPin size={18} className="text-pink-400 flex-shrink-0" />
              <span className="text-sm">{profile.location}</span>
            </div>
          </div>
        </div>

        <div>
          <h5 className="text-sm font-semibold text-slate-300 mb-3">Redes Sociales</h5>
          <div className="flex gap-3 mb-4">
            <button 
              className="p-2 bg-blue-600 hover:bg-blue-500 rounded-lg transition-all transform hover:scale-110"
              aria-label="LinkedIn"
            >
              <Linkedin size={18} className="text-white" />
            </button>
            <button 
              className="p-2 bg-sky-600 hover:bg-sky-500 rounded-lg transition-all transform hover:scale-110"
              aria-label="Twitter"
            >
              <Twitter size={18} className="text-white" />
            </button>
            <button 
              className="p-2 bg-slate-700 hover:bg-slate-600 rounded-lg transition-all transform hover:scale-110"
              aria-label="GitHub"
            >
              <Github size={18} className="text-white" />
            </button>
          </div>
          <button className="w-full py-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white rounded-lg font-medium transition-all transform hover:scale-105">
            Ver Perfil Completo
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardBack;
